import { render, staticRenderFns } from "./MyEvents.vue?vue&type=template&id=a050ba82&"
import script from "./MyEvents.vue?vue&type=script&lang=js&"
export * from "./MyEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports